import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

function ScrollToTop({ children }) {
  let location = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return children
}
ScrollToTop.propTypes = {
  children: PropTypes.object.isRequired
}
export default ScrollToTop
